"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _default = (0, _createReactClass.default)({
  displayName: 'IntegrationsActionFormField',
  propTypes: {
    children: _propTypes.default.node,
    field: _propTypes.default.object.isRequired,
    invalidFields: _propTypes.default.array.isRequired
  },
  renderError: function renderError() {
    var _this$props = this.props,
        field = _this$props.field,
        invalidFields = _this$props.invalidFields;
    var hasError = invalidFields.indexOf(field.get('name')) !== -1;

    if (!hasError) {
      return undefined;
    }

    return _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "profileSidebarModule.integrationsActionFormInvalidField",
      options: {
        field: field.get('label')
      }
    });
  },
  render: function render() {
    var _this$props2 = this.props,
        field = _this$props2.field,
        invalidFields = _this$props2.invalidFields;
    var hasError = invalidFields.indexOf(field.get('name')) !== -1;
    return _react.default.createElement(_UIFormControl.default, {
      error: hasError,
      label: field.get('label'),
      validationMessage: this.renderError()
    }, this.props.children);
  }
});

exports.default = _default;
module.exports = exports.default;